export const ENVIRONMENT_GLOBAL = {
  envName: 'global',
  loggingEnabled: true,
  production: true,
  appVersion: require('../../package.json').version,
  redirect: {
    route: '/oauth',
    teams: 'https://teams.microsoft.com/'
  },
  userFeedbackDialogDelay: 3000,
  backend: {
    endpoint: {
      paths: {
        prefix: '',
      },
      host: ''
    },
    apiKey: ''

  },
  chat: {
    endpoint: {
      paths: {
        prefix: '/chat',
        conversations: '/conversations',
        messages: '/messages',
        images: '/images',
        videos: '/videos',
        documents: '/documents',
        token: '/token',
        feedback: '/feedback'
      }
    }
  },
  downloads: {
    endpoint: {
      paths: {
        prefix: '/downloads',
        image: '/image',
        document: '/document',
        video: '/video'
      }
    }
  }
};
